import { type models } from '../models';
import { ToastModal } from './toast';

export class ToastUpModal extends ToastModal {
  constructor(rewardMessage: models.RewardMessage) {
    super(rewardMessage);
  }

  /**
   * render modal
   */
  public render(rewardMessage: models.RewardMessage) {
    this.modalDiv = document.createElement('div');
    this.modalDiv.classList = 'toast-wrapper toast-up-wrapper';

    const modalBoxDiv: HTMLDivElement = document.createElement('div');
    modalBoxDiv.classList = 'modal-box toast-box toast-up-box';

    if (!!rewardMessage.UrlToImage) {
      const image: HTMLImageElement = document.createElement('img');
      image.src = `${rewardMessage.UrlToImage}`;
      image.className = 'toast-image';
      modalBoxDiv.appendChild(image);
    }

    const box: HTMLDivElement = document.createElement('div');
    box.className = 'toast-box-content';
    modalBoxDiv.appendChild(box);

    const textDiv: HTMLDivElement = document.createElement('div');

    const title: HTMLDivElement = document.createElement('div');
    title.classList = 'modal-title toast-title';
    title.textContent = rewardMessage.Title as string;
    textDiv.appendChild(title);

    const text: HTMLDivElement = document.createElement('div');
    text.classList = 'modal-text toast-text';
    text.textContent = rewardMessage.Text as string;
    textDiv.appendChild(text);
    this.renderButtons(rewardMessage, textDiv);

    box.appendChild(textDiv);

    if (this.showCloseButton()) {
      this.renderCloseButton(box);
    }

    this.modalDiv.appendChild(modalBoxDiv);
    document.body.append(this.modalDiv);
  }
}
